import React, { useContext, useEffect, useState } from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import AppContext from "../javascript/AppContext";
import CalendarContext from '../javascript/CalendarContext';
import '../style/setting.css';

export function Setting() {
    const { updateCalendar } = useContext(CalendarContext);
    const { setting, setSetting } = useContext(AppContext)

    const [settingMode, setSettingMode] = useState(false);
    const modal = true;
    const contentStyle = {};

    const [focusDur, setFocusDur] = useState(setting.focusDur / (60 * 1000));
    const [shortBreakDur, setShortBreakDur] = useState(setting.shortBreakDur / (60 * 1000));
    const [longBreakDur, setLongBreakDur] = useState(setting.longBreakDur / (60 * 1000));
    const [maxFocusCount, setMaxFocusCount] = useState(setting.maxFocusCount);

    const [warningMessage, setWarningMessage] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        setSetting({
            focusDur: focusDur * 60 * 1000,
            shortBreakDur: shortBreakDur * 60 * 1000,
            longBreakDur: longBreakDur * 60 * 1000,
            maxFocusCount: maxFocusCount,
        });
        setSettingMode(false);
    }

    async function handleSelectCalendar() {
        try {
            await updateCalendar();
        } catch (error) {
            setWarningMessage('Access_token expires, please log in again!');
        }
    }

    return (
        <div>
            <span className={"material-symbols-outlined setting-btn p-2" + (settingMode ? " btn-select" : "")} onClick={() => setSettingMode(!settingMode)}>settings</span>
            <Popup open={settingMode} onClose={() => setSettingMode(false)} {...{ modal, contentStyle }}>
                <div className="form-container">
                    <h2 className="form-title">Settings</h2>
                    <form className="form" onSubmit={handleSubmit}>
                        <div className="first-line d-flex justify-content-between">
                            <div className="form-group">
                                <label className="form-label" htmlFor="value1">Focus</label>
                                <input className="form-input" type="number" min={0} max={59} id="value1" value={focusDur} onChange={(event) => setFocusDur(event.target.value)} />
                            </div>
                            <div className="form-group">
                                <label className="form-label" htmlFor="value2">Short Break</label>
                                <input className="form-input" type="number" min={0} max={59} id="value2" value={shortBreakDur} onChange={(event) => setShortBreakDur(event.target.value)} />
                            </div>
                            <div className="form-group">
                                <label className="form-label" htmlFor="value3">Long Break</label>
                                <input className="form-input" type="number" min={0} max={59} id="value3" value={longBreakDur} onChange={(event) => setLongBreakDur(event.target.value)} />
                            </div>
                        </div>
                        <div className="form-group justify-content-between align-items-center">
                            <label className="form-label" htmlFor="longBreakInterval">Long Break interval</label>
                            <input className="form-input" type="number" id="longBreakInterval" value={maxFocusCount} onChange={(event) => setMaxFocusCount(event.target.value)} />
                        </div>
                        <div className="form-group justify-content-between align-items-center">
                            <label className="form-label" htmlFor="longBreakInterval">Select calendar</label>
                            <button className="form-input d-flex justify-content-between" type="button" onClick={handleSelectCalendar}>Open <span className="material-symbols-outlined">open_in_new</span></button>
                        </div>
                        <div className="form-buttons">
                            <button className="form-button" type="submit">Submit</button>
                        </div>
                    </form>
                </div>

                <PopupWarning warningMessage={warningMessage} setWarningMessage={setWarningMessage} />
            </Popup>
        </div>
    )
}

function PopupWarning(props) {
    useEffect(() => {
        if (props.warningMessage) {
            // Auto hide the popup after 3 seconds
            const timeoutId = setTimeout(() => {
                props.setWarningMessage(null);
            }, 3000);

            // Cleanup function to cancel the timeout if component unmounts before timeout completes
            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [props]);

    return (
        <div className={`popup-warning ${props.warningMessage ? 'show' : ''}`}>
            <span>{props.warningMessage}</span>
        </div>
    );
}